export default __webpack_public_path__ + "static/media/polaroid36.db7cb599.jpg";